import { component } from 'picoapp'
import $ from 'quantdom'
import { debounce } from '../lib/utils'

export default component((node) => {
  const scrollHeadings = document.querySelectorAll('.scroll-heading')

  //watch scroll on mobile to check when #academy-knowledge is in view and divide into 3 sections to show the 3 mobile headings and images
  $(document).on('scroll', function () {
    handleScroll()
  })
  $(document).on('resize', function () {
    handleScroll()
  })
  document.addEventListener('DOMContentLoaded', () => {
    handleScroll()
  })

  const handleScroll = () => {
    const knowledge = document.querySelector('#academy-knowledge')
    const knowledgeRect = knowledge.getBoundingClientRect()
    const windowHeight = window.innerHeight / 3

    const stickyHeader = document.querySelector('.js-header-container')
    const stickyHeaderHeight = stickyHeader && stickyHeader.classList.contains('tw-sticky') ? stickyHeader.offsetHeight : 0
    const academySection = document.querySelector('.academy-section')
    if (stickyHeaderHeight > 0) {
      academySection.style.paddingTop = `${stickyHeaderHeight}px`
    } else {
      academySection.style.paddingTop = ''
    }

    if (knowledgeRect.top < windowHeight && knowledgeRect.bottom > 0) {
      const sectionHeight = (knowledgeRect.height - 400) / 2
      const scrollPosition = (knowledgeRect.top - 400) * -1
      const maxSections = 2
      const section =
        Math.floor(scrollPosition / sectionHeight) >= maxSections
          ? maxSections - 1
          : Math.floor(scrollPosition / sectionHeight)

      scrollHeadings.forEach((scrollHeading, index) => {
        if (index === section || (index === 0 && section === -1)) {
          scrollHeading.setAttribute('data-active', 'true')
          $(scrollHeading).find('animation-underline').attr('data-in-viewport', 'true')
          const imageNumber = scrollHeading.getAttribute('data-image')
          document
            .querySelector(`.js-knowledge-fixed-image[data-image="${imageNumber}"]`)
            .setAttribute('data-active', 'true')
        } else {
          scrollHeading.setAttribute('data-active', 'false')
          $(scrollHeading).find('animation-underline').attr('data-in-viewport', 'false')
          const imageNumber = scrollHeading.getAttribute('data-image')
          document
            .querySelector(`.js-knowledge-fixed-image[data-image="${imageNumber}"]`)
            .setAttribute('data-active', 'false')
        }
      })
    }
  }
})
